var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "notifications-page", attrs: { id: "default-page" } },
    [
      _c("div", { staticClass: "container full-width" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "search-result-top" },
            [
              _c("div", { staticClass: "top" }, [
                _c("div", { staticClass: "left" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.title))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm.unreadCount
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          on: { click: _vm.markAllRead }
                        },
                        [
                          _vm._v(
                            "\n                            Mark All Read\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.notifications, function(notification) {
                return [
                  notification.data.title
                    ? _c(
                        "div",
                        { class: _vm.notificationClass(notification) },
                        [
                          _c("div", { staticClass: "read-icon" }, [
                            notification.read_at
                              ? _c("i", {
                                  staticClass: "fa fa-envelope-open-o",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _c("i", {
                                  staticClass:
                                    "fa fa-envelope-o cursor-pointer",
                                  attrs: {
                                    title: "click to mark as read",
                                    "aria-hidden": "true"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.markRead([notification.id])
                                    }
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          notification.data.route
                            ? _c(
                                "a",
                                {
                                  staticClass: "notification-grid",
                                  attrs: { href: notification.data.route }
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.displayDate(
                                            notification.created_at
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(notification.data.title) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(notification.data.message) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              )
                            : [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.displayDate(notification.created_at)
                                    ) +
                                    " - " +
                                    _vm._s(notification.data.title) +
                                    " - " +
                                    _vm._s(notification.data.message) +
                                    "\n                        "
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              !_vm.notifications || _vm.notifications.length === 0
                ? _c("div", [
                    _vm._v(
                      "\n                    You have no notifications\n                "
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ea0e13c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea0e13c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/NotificationsPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1ea0e13c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/NotificationsPage.vue
// module chunks = 0